module.exports = __webpack_public_path__ + "5025d08794d1053c611b80032551f0aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/faqtel.png
// module id = 757
// module chunks = 0